import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];
let _fetchedAll = false;

export const getCompliance = ({complianceId, complianceName, complianceSkills}) => {
    const id = Number(complianceId) || null;

    return id && ({
        id,
        name: complianceName,
        skillCount: complianceSkills
    });
};

export const getProgramme = ({programmeId, programmeName, programmeDescription, programmeCourses}) => {
    const id = Number(programmeId) || null;
    return id && ({
        id,
        name:        programmeName,
        description: programmeDescription,
        courses:     programmeCourses
    });
};

const sanitise = ({id, assignmentId, complianceId, ...entity}) => ({
    id: Number(id),
    ...entity,
    assignmentId: Number(assignmentId) || null,
    complianceId: Number(complianceId) || null,
});

let AssignmentStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
         return [..._entities];
    },
    getById: function(id) {
        const searchId = Number(id); // should be sanitised on call
        return _entities.find(({id}) => id === searchId);
    },
    add: function(entity) {
        entity = sanitise(entity);
        const index = _entities.findIndex(({id}) => id === entity.id);
        if (0 <= index) {
            _entities[index] = entity;
        } else {
            _entities.push(entity);
        }
    },

    delete: function(id) {
        const deleteId = Number(id);
        _entities = _entities.filter(({id}) => id !== deleteId);
    },

    fetchedAll: () => (_fetchedAll)

});

AssignmentStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.ASSIGNMENT_LIST:
            if (action.data.length === 0) {
                _fetchedAll = true;
            } else {
                action.data.map(AssignmentStore.add);
                _fetchedAll = false;
            }
            AssignmentStore.emitChange();
            break;

        case ActionTypes.ASSIGNMENT_LIST_ERROR:
            AssignmentStore.emitChange();
            break;

        case ActionTypes.ASSIGNMENT_INFO:
            AssignmentStore.add(action.data);
            AssignmentStore.emitChange();
            break;

        case ActionTypes.ASSIGNMENT_INFO_ERROR:
            AssignmentStore.emitChange();
            break;

        case ActionTypes.ASSIGNMENT_UPDATE:
            AssignmentStore.add(action.data);
            AssignmentStore.emitChange();
            break;
            
        case ActionTypes.ASSIGNMENT_DELETE:
            AssignmentStore.delete(action.payload.id);
            AssignmentStore.emitChange();
            break;

        default:
            break;
    }
});

export default AssignmentStore;
